import React from 'react'
import styled from 'styled-components'
import Reveal from 'react-reveal/Reveal'

const Wrapper = styled.div`
  background: ${props => props.theme.colors.bcca};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

const Info = styled.div`
  max-width: 800px;
  padding: 1rem;
`

const Heading = styled.h3`
  font-family: 'PT Serif', serif;
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 1.4;
  margin: 0 0 2rem 0;
  position: relative;
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    font-size: 1.75rem;
  }
`

const Text = styled.div`
  position: relative;
  line-height: 1.5;
  p {
    color: #fff;
    font-size: 0.75rem;
    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      font-size: 1rem;
    }
    &:last-child {
      margin: 0;
    }
  }
  a {
    color: #fff;
  }
`

const Intro = props => {
  return (
    <Wrapper>
      <Reveal>
        <Info>
          <Text>
            <p><em>This campaign is sponsored by the <a href="https://www.bccassn.com">BC Construction Association</a>, <a href="http://www.cca-acc.com/">CCA</a>, and four <a href="https://www.bccassn.com/about-us/regional-associations/">Regional Construction Associations</a>.</em></p>
          </Text>
        </Info>
      </Reveal>
    </Wrapper>
  )
}

export default Intro



// WEBPACK FOOTER //
// ./src/components/Footer.js